import AccountCardAddressBookTable from './AccountCardAddressBookTable';
import withModal from '../../../../../../components/global/modal/withModal';

export const ACCOUNT_CARD_ADDRESS_BOOK_TABLE =
  'modal/ACCOUNT_CARD_ADDRESS_BOOK_TABLE';

export default withModal(AccountCardAddressBookTable, {
  name: ACCOUNT_CARD_ADDRESS_BOOK_TABLE,
  dismissible: false,
  size: 'lg',
  hideHeader: true,
  className: 'account-card-address-book-table-modal modal-floating-panel',
  overlayClassName: 'account-card-address-book-table-modal-overlay',
});
